module.exports = __webpack_public_path__ + "media/images/brand/bg_mv-bcab6625cd35e8e33b2685a7c4f9d4bd.jpg";